import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { CropOriginal } from '@material-ui/icons';

export default function ImageUpload() {
    const [paths, setPaths] = useState([]);
    const [isImageUploaded, setIsImageUploaded] = useState(false);

    const onDrop = useCallback(acceptedFiles => {
        setPaths(acceptedFiles.map(file => URL.createObjectURL(file)));
        setIsImageUploaded(true);
    },    [setPaths, setIsImageUploaded]);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

    return (
        <div>
            {!isImageUploaded ? (
                <div className="dropzone-transaction" {...getRootProps()}>
                    <input {...getInputProps()}/>
                    <CropOriginal/>
                    <p>Upload client photo</p>
                </div>
            ) : (
                <div>
                    {paths.map(path => (
                        <img key={path} src={path} style={{ width: "250px", height: "250px" }}/>
                    ))}
                </div>
            )}
        </div>
    );
};